export enum REFERENTIAl_STATES_ENDPOINTS {
  ASSET = "state/assets",
  INTERVENTION = "state/interventions",
  JOB_MODULE = "state/job-modules",
  OBSERVATION = "state/observations",
  PROJECT = "state/projects",
  INTERVENTIONTEMPLATE = "state/intervention-templates",
}
